export default __webpack_public_path__ + "static/media/Github.f020857c.svg";